import React, { useMemo } from "react";
import { Chart } from "react-google-charts";

const PieChartMachineStatus = ({
  cycleTimeData,
  stoppedData,
  shortStoppedData,
}) => {
  const timeStringToSeconds = (timeString) => {
    if (typeof timeString === "string") {
      const cleanedString = timeString.replace(/,/g, "");
      return parseFloat(cleanedString) || 0;
    }
    return parseFloat(timeString) || 0;
  };

  const secondsToTimeString = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    return `${hours.toString()}:${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const totalCycleTime = useMemo(() => {
    if (!cycleTimeData?.values?.length) return 0;
    return cycleTimeData.values
      .map(timeStringToSeconds)
      .reduce((sum, value) => sum + value, 0);
  }, [cycleTimeData]);

  const totalStoppedTime = useMemo(() => {
    if (!stoppedData?.values?.length) return 0;
    return stoppedData.values
      .map(timeStringToSeconds)
      .reduce((sum, value) => sum + value, 0);
  }, [stoppedData]);

  const totalShortStoppedTime = useMemo(() => {
    if (!shortStoppedData?.values?.length) return 0;
    return shortStoppedData.values
      .map(timeStringToSeconds)
      .reduce((sum, value) => sum + value, 0);
  }, [shortStoppedData]);

  const pieData = [
    { label: "Aktif Çalışma", value: totalCycleTime },
    { label: "Duruş", value: totalStoppedTime },
    { label: "Kısa Duruş", value: totalShortStoppedTime },
    { label: "Setup", value: 1200 },
  ];

  const chartData = [
    ["Durum", "Süre", { role: "tooltip", type: "string" }],
    ...pieData.map((item) => [
      item.label,
      item.value, // Saniye cinsinden veri
      `Durum: ${item.label}\nSüre: ${secondsToTimeString(item.value)}`, // Tooltip metni
    ]),
  ];

  const options = {
    title: "Makine Duruş Durumları",
    is3D: true,
    chartArea: { width: "90%", height: "90%" },
    colors: ["#05588C", "#0071BC", "#B5D7F3", "#E1EFFB"],
    legend: { position: "right", alignment: "center" },
  };
  if (!cycleTimeData && !stoppedData && !shortStoppedData) {
    return <div className="text-center text-gray-500">Duruş Bilgisi Yok</div>;
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-4 h-auto flex flex-col items-center justify-center">
      <div className="text-center mb-4">
        {/* <h3 className="text-lg font-bold">Toplam Süreler</h3> */}
        <div className="flex items-center space-x-1">
          <span  style={{ backgroundColor: "#05588C" }} className="w-4 h-4 inline-block rounded-full"></span>
          <p>Aktif Çalışma: {secondsToTimeString(totalCycleTime)}</p>
        </div>
        <div className="flex items-center space-x-1">
          <span  style={{ backgroundColor: "#0071BC" }} className="w-4 h-4 inline-block rounded-full"></span>
          <p>Duruş: {secondsToTimeString(totalStoppedTime)}</p>
        </div>
        <div className="flex items-center space-x-1">
          <span  style={{ backgroundColor: "#B5D7F3" }} className="w-4 h-4 inline-block rounded-full"></span>
          <p>Kısa Duruş: {secondsToTimeString(totalShortStoppedTime)}</p>
        </div>
        <div className="flex items-center space-x-1">
          <span  style={{ backgroundColor: "#E1EFFB" }} className="w-4 h-4 inline-block rounded-full"></span>
          <p>Setup: {secondsToTimeString(totalShortStoppedTime)}</p>
        </div>
      </div>
      <Chart
        chartType="PieChart"
        data={chartData}
        options={options}
        width={"100%"}
        height={"400px"}
      />
    </div>
  );
};

export default PieChartMachineStatus;
